<template>
  <div class="select-group" role="group">
    <template v-for='index in count' v-bind:key="index">
      <input @change="change" type="radio" :value="`${index}`" class="btn-check" :name="name" :id="`${name}-${index}`"
             autocomplete="off" :checked="getChecked(index)">
      <label class="select-group-btn" :for="`${name}-${index}`">X{{ index }}</label>
    </template>
  </div>
</template>

<script>
import {API} from "@/getapi";

export default {
  name: "BtnGroupXMobile",
  inject: ['URL_SENDMODE'],
  props: {
    count: Number,
    name: String
  },
  data() {
    return {
      checked: 2
    }
  },
  created() {

    let xWeek = this.$cookies.get('xWeek')
    if (this.$store.state.xWeek > this.count) {
      this.$store.state.xWeek = this.count;
      this.$cookies.set('xWeek', this.count, Infinity);
      xWeek = this.count
    }

    if (!xWeek) {
      this.$store.state.xWeek = 1;
      xWeek = 1
      this.$cookies.set('xWeek', 1, Infinity);
    }else{
      this.$store.state.xWeek = xWeek;
      this.$cookies.set('xWeek', xWeek, Infinity);
    }
    this.sendMode({'u_xsize_week':xWeek})
  },
  methods: {
    change: function (e) {
      e.preventDefault();
      let value = e.currentTarget.value
      this.$store.state.xWeek = value;
      this.$cookies.set('xWeek', value, Infinity);
      this.sendMode({'u_xsize_week':value})
    },
    sendMode(saveData){
      API.get(this.URL_SENDMODE, saveData).then(({data}) => {

        if (data.isOk) {
          let dataResult = data.result
          console.log(dataResult)
        } else {
          console.error("Error:", data.errors)
        }
      }).catch((err) => {
        API.catch(err)
      })
    },
    getChecked: function (num) {
      if (num == this.$store.state.xWeek) {
        return true;
      }
      return false
    }
  },
}
</script>

<style scoped>

.select-group {
  display: inline-flex;

}

.select-group .select-group-btn {
  border: 1px solid #E07A5F;
  border-right: none;
  padding: 8px 8px;
  border-radius: 0px;
  font-size: .9rem;
  line-height: 1rem;
  background: #FFFFFF;
}

.select-group .select-group-btn:last-child {
  border-right: 1px solid #E07A5F;
  border-radius: 0px 5px 5px 0px;
}

.select-group .btn-check:first-child + .select-group-btn {
  border-radius: 5px 0px 0px 5px;
}

.select-group .btn-check:checked + .select-group-btn {
  background: #E07A5F;
  color: #fff;
}
</style>